import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';

const ID = 'accessSystem' as const;

export const accessSystemTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const value = getTermValue('enter')(jsonQuery);

    if (value == null) {
      return null;
    }

    return [{ label: value ? 'По пропускам' : 'Свободный', value: ID }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['enter'])(jsonQuery),
};
